import React from 'react';
export const AboutSection = () => {
  return <section id="about" className="py-20 bg-gray-50" data-id="element-30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-33">
            About Us
          </h2>
          <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-34"></div>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-35">
          <div className="md:w-1/2" data-id="element-36">
            <p className="text-lg mb-6 leading-relaxed" data-id="element-37">
              At Sapis Capital Group, we believe in forging lasting partnerships
              with visionary entrepreneurs and management teams. Our investment
              philosophy centers on sustainable growth, ethical business
              practices, and innovative approaches to value creation.
            </p>
            <p className="text-lg mb-6 leading-relaxed" data-id="element-38">
              We take a long-term view on capital deployment, focusing on
              companies with strong fundamentals and exceptional growth
              potential. Our team brings decades of combined experience across
              multiple industries, providing not just financial resources but
              strategic guidance and operational expertise.
            </p>
            <p className="text-lg leading-relaxed" data-id="element-39">
              Through disciplined investment strategies and collaborative
              partnerships, we aim to deliver superior returns while making a
              positive impact on the businesses and communities we serve.
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-40">
            <div className="grid grid-cols-2 gap-4" data-id="element-41">
              <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-42">
                <div className="text-[#38b2ac] text-4xl font-bold mb-2" data-id="element-43">
                  25+
                </div>
                <div className="text-gray-600" data-id="element-44">Portfolio Companies</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-45">
                <div className="text-[#38b2ac] text-4xl font-bold mb-2" data-id="element-46">
                  $150M+
                </div>
                <div className="text-gray-600" data-id="element-47">Assets Under Management</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-48">
                <div className="text-[#38b2ac] text-4xl font-bold mb-2" data-id="element-49">
                  12+
                </div>
                <div className="text-gray-600" data-id="element-50">Years Experience</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-51">
                <div className="text-[#38b2ac] text-4xl font-bold mb-2" data-id="element-52">4</div>
                <div className="text-gray-600" data-id="element-53">Global Offices</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};